import {Component, EventEmitter, Input, Output, ViewChild, OnChanges, SimpleChanges} from '@angular/core';
import {TableConfig, TableConfigUtils} from '@app/shared/util/table-config.utils';
import {Log} from 'ng2-logger';
import {TransportDetailsModelComponent} from '@app/roles/milkrun-operator/pages/transportation-requests';
import * as moment from 'moment';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-transport-requests-table',
    templateUrl: './transport-requests-table.component.html',
    styleUrls: ['./transport-requests-table.component.scss']
})
export class TransportRequestsTableComponent implements OnChanges {
    _logger = Log.create(TransportRequestsTableComponent.name);

    @ViewChild(TransportDetailsModelComponent, {static: false}) transportDetailsModel: TransportDetailsModelComponent;
    _transports: any[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() statusFilters = [];
    @Input() isMaterial = false;

    @Output() pageChange = new EventEmitter<any>();

    @Output() loadTransportAtAtom = new EventEmitter<any>();
    @Output() unloadTransportAtAtom = new EventEmitter<any>();

    @Output() loadTransportAtLine = new EventEmitter<any>();
    @Output() unloadTransportAtLine = new EventEmitter<any>();

    constructor(private translate: TranslateService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['transports'] && this.transports.length > 0) {
            this.transports = TableConfigUtils.addColorToToolTransportByPriority(this.transports);
            this.transports.forEach(function (transportDetails) {
                transportDetails.load = (transportDetails.status === 'Processed' && !transportDetails.atLine) ||
                    (transportDetails.status === 'New' && transportDetails.atLine);
                transportDetails.isRequest = (transportDetails.status === 'Processed' && !transportDetails.atLine) ||
                    (transportDetails.status === 'InTransport' && transportDetails.atLine);
            });
        }
    }

    onPageChange(tableConfig: TableConfig) {
        this._logger.info('onPageChange::', this.tableConfig);
        this.pageChange.emit(tableConfig);
    }

    processTransport(transportInfo: any) {
        this.transportDetailsModel.open(transportInfo);
    }

    onLoadTransport(transport: any) {
        this._logger.info('onLoadToolRequest::', transport);
        if (transport.isRequest) {
            this.loadTransportAtAtom.emit(transport);
        } else {
            this.loadTransportAtLine.emit(transport)
        }
    }

    onUnloadTransport(transport: any) {
        this._logger.info('onUnloadToolRequest::', transport);
        if (transport.isRequest) {
            this.unloadTransportAtLine.emit(transport);
        } else {
            this.unloadTransportAtAtom.emit(transport);
        }
    }

    get transports() {
        return this._transports;
    }

    getExceededStatus(transport: any): 'success' | 'warning' | 'important' | null {
        if (!transport.toolMaxTransportTime) {
            return null;
        }

        const created = moment(transport.createdDate);
        const now = moment();
        const minutesPassed = now.diff(created, 'minutes');
        const max = transport.toolMaxTransportTime;

        if (minutesPassed <= max) {
            return 'success';
        }

        const exceededPercent = ((minutesPassed - max) / max) * 100;

        if (exceededPercent <= 20) {
            return 'warning';
        }

        return 'important';
    }

    getUrgencyTooltip(transport: any): string {
        if (!transport.toolMaxTransportTime) {
            return '';
        }

        const created = moment(transport.createdDate);
        const now = moment();

        const totalMinutesPassed = now.diff(created, 'minutes');
        const max = transport.toolMaxTransportTime;
        const minutesPassed = Math.max(0, totalMinutesPassed - max);

        if (totalMinutesPassed <= max) {
            return this.translate.instant(
                'milkrun.transportation-requests.tooltip.withinTime',
                {minutesPassed, max}
            );
        }

        const exceededPercent = Math.round(((totalMinutesPassed - max) / max) * 100);

        if (exceededPercent <= 20) {
            return this.translate.instant(
                'milkrun.transportation-requests.tooltip.exceededSlightly',
                {minutesPassed, max}
            );
        }

        return this.translate.instant(
            'milkrun.transportation-requests.tooltip.exceededHeavily',
            {minutesPassed, max}
        );
    }

    @Input()
    set transports(requests) {
        this._transports = requests;
    }

    createdDate(createdDate): any {
        return moment(createdDate).format('DD/MM/YYYY - HH:mm');
    }

    hasStandardTime(transport: any) {
        return transport.isRequest;
    }
}
